// extracted by mini-css-extract-plugin
export default {"header":"header_header__bR3gA","title":"header_title__s+J+1"};